import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { ROUTESLIST } from '@/static/urls';
import FormField from '@/components/forms/form-field';
import MultiSelectField from '@/components/forms/multi-select-field';
import DatePickerField from '@/components/forms/date-picker';
import ManyAutocompleteField from '@/components/forms/many-autocomplete';
//import { FORMS } from '@/static/common.js';
import api, { setErrors, arrangeData, convertDateToDb } from '@/middlewares/api';

import bgImg from './crate-step2.jpg';

class AddCrateStep2 extends Component {

    constructor(props) {
        super(props);
        this.stepSubmit = this.stepSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        const {prevStep, rawValues} = this.props;
        prevStep(rawValues);
    }

    stepSubmit(data) {
        //let formData = arrangeData(data, null, ["song_writers", "song_publishers"]);               
        let formData = arrangeData(data, null, ["publishers", "labels"]);
        formData.release_date = convertDateToDb(formData.release_date); 
        return new Promise((resolve, reject) => {
            api.post('crate/step/two', formData)
            .then((response) => {               
                this.props.nextStep(formData, data);
                return resolve(null);
            })
            .catch((err) => {
                if(! err.response) return;
                if(err.response.status === 422) {
                    return reject(setErrors(err.response));                            
                }            
            });
        });
    }
    // produced_by
    // artist_manager
    // publishers[]
    // labels[]
    // video_url
    // genres[]
    // release_date
    

    render() {
        const secStyle = { backgroundImage: "url(" +  bgImg  + ")"};
        const { handleSubmit, crateGenresOptions, submitting } = this.props;
        return (
            <section className="entity-sec banner-filter banner-filter_fw" style={ secStyle }>
                <div className="content">
                    <div className="entity-sec__top">  
                        <h2 className="head-shadow">ADD A NEW SONG</h2>
                        <h3 className="head">
                            Step 2 of 3: Production information
                        </h3>
                        <div className="form-step__top-desc">                            
                        </div>
                    </div>
                    <div className="form-step__body">
                        <form onSubmit={handleSubmit((data) => { 
                                return this.stepSubmit(data);
                            }) } className="form-layout"
                            noValidate>
                            <div className="form-row">
                                <div className="form-col_2">                                
                                    <Field                            
                                        name="produced_by"
                                        component={FormField}                                        
                                        type="text"
                                        placeholder="Set Producer's Name	"
                                        label="Produced By"                            
                                    />                                    
                                    <Field                            
                                        name="video_url"
                                        component={FormField}
                                        type="text"
                                        required={true}
                                        placeholder="Set URL to music video"
                                        label="YouTube URL "                            
                                    /> 
                                </div>
                                <div className="form-col_2">
                                    <Field                            
                                        name="artist_manager"
                                        component={FormField}                                        
                                        type="text"
                                        placeholder="Set manager's first and last name"
                                        label="Artist Manager"                            
                                    />                                     
                                    <Field                            
                                        name="genres"
                                        component={MultiSelectField}
                                        options={crateGenresOptions}
                                        placeholder="Select Genre"
                                        label="Genre"
                                        required={true}                            
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-col_2"> 
                                    <Field                            
                                        name="publishers"                                        
                                        label="Published By"
                                        required={true}
                                        component={ManyAutocompleteField}
                                        url="clear/publisher/search"                                       
                                        placeholder="Set Publisher(s)"                            
                                    />
                                </div>
                                <div className="form-col_2"> 
                                    <Field                            
                                        name="labels"
                                        required={true}
                                        component={ManyAutocompleteField}
                                        url="clear/label/search"                                       
                                        placeholder="Set label"  
                                        label="Record Label"                            
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-col_2"> 
                                    <Field                            
                                        name="release_date"
                                        component={DatePickerField}                                       
                                        placeholder="MM/DD/YY"
                                        required={true}
                                        label="Release Date" 
                                        note="State the date your project will be released."                                                               
                                    />
                                </div>
                            </div>       
                            <div className="submit-row_txt">
                                <p className="as-text">
                                    By clicking Confirm button you are agreeing to the 
                                    <Link to={ ROUTESLIST.STATIC_TERMS } className="link-thin"
                                        target="_blank" rel="noopener noreferrer"
                                        >Terms and Conditions.
                                    </Link>
                                </p>                                
                            </div>
                            <div className="submit-row submit-row_txt">  
                                    <button className="btn btn-second" onClick={ this.goBack }
                                        type="button">Back</button>                                  
                                    <button className="btn btn-primary" disabled={ submitting }
                                        type="submit">Next</button>
                            </div>
                        </form>                        
                    </div>
                </div>
            </section>            
        )
    }
}

const AddCrateStep2Form =  reduxForm({
    form: 'add-crate-step2',
    enableReinitialize: true  
  })(AddCrateStep2);

//export default AddCrateStep2Form;
const mapState = (state) => {
    return {
        rawValues: getFormValues('add-crate-step2')(state)
    }
}
export default connect(mapState)(AddCrateStep2Form);
